import { render, staticRenderFns } from "./modularChild5.vue?vue&type=template&id=b9c13966&scoped=true"
import script from "./modularChild5.vue?vue&type=script&lang=js"
export * from "./modularChild5.vue?vue&type=script&lang=js"
import style0 from "./modularChild5.vue?vue&type=style&index=0&id=b9c13966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c13966",
  null
  
)

export default component.exports